export default "__VITE_ASSET__D0JwGzR0__"